import * as types from './type'

const initialState = {
  data: [],
  dataList: [],
  loading: false,
  createSuccess: false,
  editLoad: false,
  deleteLoad:false,
}

export const smstemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SMSTEMPLATE:
      return {
        ...state,
        ...{ loading: true, createSuccess: false },
      }

    case types.GET_SMSTEMPLATE_SUCCESS:
      return {
        ...state,
        ...{
          dataList: action.payload,
          loading: false
        }
      }

    case types.GET_SMSTEMPLATE_FAIL:
      {
        return {
          ...state,
          ...{ dataList: [], loading: false }
        }
      }

    case types.CREATE_SMSTEMPLATE:
      return {
        ...state,
        ...{ loading: true }
      }

    case types.CREATE_SMSTEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        createSuccess: true,
      }

    case types.CREATE_SMSTEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        data: action.payload.response.data,
      }

    
    case types.RESET_MESSAGE_ERROR:
      return {
        ...state,
        loading: false,
        data: []
      }
      //edit
      case types.EDIT_SMSTEMPLATE: 
      return {
          ...state,
          editLoad: true,

      }
      case types.EDIT_SMSTEMPLATE_SUCCESS:
      return {
          ...state,
          editLoad: false,
      }
      //remove
      case types.DELETE_SMSTEMPLATE: 
      return {
          ...state,
          deleteLoad: true,

      }
      case types.DELETE_SMSTEMPLATE_SUCCESS:
      return {
          ...state,
          deleteLoad: false,
      }
    default:
      return state
  }
}